import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgRefreshSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M11.8015 12.7004C11.1561 13.321 10.397 13.7992 9.56998 14.1063C8.74295 14.4135 7.86494 14.5434 6.98865 14.4879C6.16 14.4494 5.34696 14.2395 4.59658 13.8709C3.8462 13.5023 3.17346 12.982 2.61734 12.3402C2.06122 11.6984 1.63273 10.9478 1.35684 10.1321C1.08095 9.31633 0.963084 8.45171 1.01006 7.58811C1.12967 6.16696 1.68304 4.82296 2.58888 3.75389C3.49472 2.68482 4.70537 1.94705 6.04306 1.64829C7.38076 1.34953 8.77501 1.50585 10.0212 2.09427C11.2675 2.6827 12.3 3.67188 12.9672 4.9173L13.9637 6.9955M15 3.92028L14.0335 7.03758L11.0143 6.04009"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgRefreshSmall.displayName = 'SvgRefreshSmall';
const RefreshSmall = withForgeIconProps(SvgRefreshSmall, {
  name: 'Refresh',
  usage: 'Use to reload or refresh a page or view.',
  related: 'update, new, recent',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default RefreshSmall;
